import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions, selectors } from 'farmx-redux-core';
import PropTypes from 'prop-types';
import { Tag, Select } from 'antd';
import ItemSelect from './ItemSelect';
import BlockOption from './BlockOption';
import DropdownModal from './sensor/DropdownModal';
import SensorSelectContext from './sensor/SensorSelectContext';

const { Option } = Select;

const {
  loadFarmData,
} = actions;

const {
  selectAllBlocks,
} = selectors;

const blockTagRender = (args) => {
  const {
    closable, onClose, label,
  } = args;
  return (
    <Tag
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label.props ? label.props.block.name : label}
    </Tag>
  );
};

const defaultItemRenderer = (d) => (
  <Option key={d.id} value={d.id} label={d.name} data-testid={`${d.name}`}>
    <BlockOption block={d} />
  </Option>
);

const BlockSelect = ({
  loadItems,
  items,
  mode,
  renderItem,
  onSelect,
  onChange,
  tagRender,
  placeholder,
  defaultOption,
  value,
}) => {
  const dispatch = useDispatch();
  const data = useSelector(selectAllBlocks);
  const blocks = items || data;
  const [modal, setModalState] = useState(false);
  const mobileScreen = window.innerWidth < 599;
  const dropdownStyleValues = useContext(SensorSelectContext);

  useEffect(() => {
    if (loadItems) loadItems();
    else dispatch(loadFarmData());
  }, [dispatch, loadItems]);

  let dropdownStyle = null;
  if (window.innerWidth < 599) dropdownStyle = { minWidth: '60%' };

  function onSelectAction(d) {
    if (onSelect) onSelect(d);
    if (!mobileScreen) {
      setModalState(false);
    }
  }
  return (
    <ItemSelect
      mode={mode}
      renderItem={renderItem}
      items={blocks}
      onSelect={onSelectAction}
      onChange={onChange}
      tagRender={tagRender || blockTagRender}
      placeholder={placeholder}
      defaultOption={defaultOption}
      value={value}
      filterOption={(input, option) => option.children.props.block.name.toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
        || (option.children.props.block.ranch
          && option.children.props.block.ranch.name
            .toLowerCase().indexOf(input.toLowerCase()) >= 0)}
      dropdownStyle={dropdownStyle}
      menuIsOpen={mobileScreen ? modal : undefined}
      dropdownRender={mobileScreen ? (menu) => (
        <DropdownModal
          title="Block Select"
          displayOptions={menu}
          mobileScreen={mobileScreen}
          onClick={() => setModalState(false)}
        />
      ) : undefined}
      dropdownStyleValues={dropdownStyleValues}
      onDropdownVisibleChange ={ mobileScreen ? () => setModalState(true) : undefined }
    />
  );
};

BlockSelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
};

BlockSelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  value: null,
};

export default BlockSelect;
